import React, { memo } from "react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StockPick } from "@/types/stock"; // Import the StockPick type
import StockItem from "./StockItem"; // Import StockItem

interface PremiumUpgradeSectionProps {
  nextItem?: StockPick; // Optional: show a blurred preview of the next item
  totalHidden: number;
  onSubscribe: () => void;
}

export const PremiumUpgradeSection = memo(({ nextItem, totalHidden, onSubscribe }: PremiumUpgradeSectionProps) => (
  <div className="relative rounded-lg border border-dashed border-white/20 bg-gradient-to-br from-black/30 to-blue-900/20 overflow-hidden">
    {/* Blurred Background Item (Optional) */}
    {nextItem && (
      <div className="absolute inset-0 opacity-10 blur-sm">
        {/* Use the imported StockItem component */}
        <StockItem stock={nextItem} />
      </div>
    )}
    {/* Overlay Content */}
    <div className="relative p-4 flex flex-col items-center justify-center text-center bg-black/50">
      <Lock className="h-5 w-5 text-blue-400 mb-2" />
      <p className="text-sm text-white/90 font-medium mb-1">
        Unlock {totalHidden} More AI Pick{totalHidden > 1 ? 's' : ''}
      </p>
      <p className="text-xs text-muted-foreground mb-3">Upgrade for full access to AI stock analysis.</p>
      <Button
        variant="outline"
        size="sm"
        className="bg-blue-500/20 hover:bg-blue-500/30 text-blue-400 border-blue-500/40 shadow-md"
        onClick={onSubscribe}
      >
        Upgrade Now
      </Button>
    </div>
  </div>
));

PremiumUpgradeSection.displayName = 'PremiumUpgradeSection';

export default PremiumUpgradeSection;
